import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Constraints } from '../../constraints/index.js';
import { jsx } from '@emotion/react';
import mergeDefaultProps from '../../../utils/merge-default-props.js';
import getFieldId from '../../../utils/get-field-id.js';
import { TextInput } from '../../inputs/text-input/text-input.js';
import createSequentialId from '../../../utils/create-sequential-id.js';
import { Stack } from '../../spacings/stack/stack.js';
import { FieldLabel } from '../../field-label/field-label.js';
import { FieldMessage } from '../../field-message/field-message.js';

var _excluded = ["description", "error", "helpText", "helperText", "hint", "hintPosition", "horizontalConstraint", "inputProps", "InputProps", "inputRef", "leftIcon", "optionalText", "size", "title", "touched", "type", "warning"];
var sequentialId = createSequentialId('text-field-');
var defaultProps = {
  horizontalConstraint: 'scale',
  type: 'text',
  size: 'l'
};
var TextFieldInternal = function TextFieldInternal(props, ref) {
  var propsInternal = mergeDefaultProps(props, defaultProps);
  var description = propsInternal.description,
      error = propsInternal.error,
      helpText = propsInternal.helpText,
      helperText = propsInternal.helperText,
      hint = propsInternal.hint,
      hintPosition = propsInternal.hintPosition,
      horizontalConstraint = propsInternal.horizontalConstraint,
      _propsInternal$inputP = propsInternal.inputProps,
      inputProps = _propsInternal$inputP === void 0 ? {} : _propsInternal$inputP,
      _propsInternal$InputP = propsInternal.InputProps,
      InputProps = _propsInternal$InputP === void 0 ? {} : _propsInternal$InputP,
      inputRef = propsInternal.inputRef,
      leftIcon = propsInternal.leftIcon,
      optionalText = propsInternal.optionalText,
      _propsInternal$size = propsInternal.size,
      size = _propsInternal$size === void 0 ? 'l' : _propsInternal$size,
      title = propsInternal.title,
      touched = propsInternal.touched,
      type = propsInternal.type,
      warning = propsInternal.warning,
      rest = _objectWithoutProperties(propsInternal, _excluded);
  var id = getFieldId(rest, {}, sequentialId);
  var showError = touched && !!error;
  var showWarning = touched && !!warning;
  return jsx(Constraints.Horizontal, {
    constraint: horizontalConstraint
  }, jsx(Stack, {
    scale: "xs"
  }, jsx(FieldLabel, {
    description: description,
    hint: hint,
    hintPosition: hintPosition,
    htmlFor: id,
    optionalText: optionalText,
    title: title
  }), jsx(TextInput, _extends({
    ref: inputRef || ref,
    hasError: showError,
    hasWarning: showWarning,
    horizontalConstraint: "scale",
    leftIcon: leftIcon,
    size: size,
    type: type
  }, rest, inputProps, InputProps)), jsx(FieldMessage, {
    error: error,
    helpText: helpText || helperText,
    isVisible: touched,
    warning: warning
  })));
};
TextFieldInternal.displayName = 'TextField';
var TextField = React.forwardRef(TextFieldInternal);

export { TextField };
//# sourceMappingURL=text-field.js.map
